export type AppUrlZone = 'ir' | 'com'

const DEFAULT_APP_BASE_URL: Record<AppUrlZone, string> = {
    ir: 'https://app.lummeny.ir',
    com: 'https://app.lummeny.com',
}

/** Map marketing-site hostnames to the product app origin. */
const MARKETING_HOST_TO_APP: Record<string, string> = {
    'lummeny.ir': DEFAULT_APP_BASE_URL.ir,
    'www.lummeny.ir': DEFAULT_APP_BASE_URL.ir,
    'lummeny.com': DEFAULT_APP_BASE_URL.com,
    'www.lummeny.com': DEFAULT_APP_BASE_URL.com,
}

/**
 * Resolve the product app base URL from env, with a zone-specific fallback.
 *
 * Reads `NEXT_PUBLIC_APP_URL` first, then `NEXT_PUBLIC_REDIRECT_URL`.
 * If env points at a marketing domain (e.g. lummeny.ir), normalizes to app.*.
 */
export function resolveAppBaseUrl(zone: AppUrlZone): string {
    const fallback = DEFAULT_APP_BASE_URL[zone]
    const fromEnv = process.env.NEXT_PUBLIC_APP_URL?.trim()
        || process.env.NEXT_PUBLIC_REDIRECT_URL?.trim()

    if (!fromEnv) {
        return fallback
    }

    try {
        const url = new URL(fromEnv)
        const mapped = MARKETING_HOST_TO_APP[url.hostname.toLowerCase()]
        if (mapped) {
            return mapped
        }
        return url.origin
    } catch {
        return fallback
    }
}

export function appUrlsFromBase(baseUrl: string) {
    const appBaseUrl = baseUrl.replace(/\/$/, '')
    return {
        redirectUrl: `${appBaseUrl}/`,
        loginUrl: `${appBaseUrl}/auth/login`,
        signUpUrl: `${appBaseUrl}/auth/register`,
    }
}
